// extracted by mini-css-extract-plugin
module.exports = {"blockScrolling":"globalScrolling_blockScrolling__mSuEg"};